import { render, staticRenderFns } from "./SpecialGeneticsIcons.vue?vue&type=template&id=456ad198&scoped=true&"
import script from "./SpecialGeneticsIcons.vue?vue&type=script&lang=js&"
export * from "./SpecialGeneticsIcons.vue?vue&type=script&lang=js&"
import style0 from "./SpecialGeneticsIcons.vue?vue&type=style&index=0&id=456ad198&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456ad198",
  null
  
)

export default component.exports